import { useOffersContext } from '@/context/useOffersContext'
import { useApp } from '@/hooks/useApp'
import { useGetGrouppedAvailablePackages } from '@/hooks/useOfferPackage'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { OfferPackageSettingsFormTabs, type OfferPackageSettingsFormProps } from 'BrokerTsLib/src/dtos'
import { useEffect, useState } from 'react'
import { OfferSettingsModal } from '../../OfferSettingsModal'
import { OfferPackageSettingsFormAddons } from './OfferPackageSettingsFormAddons'
import { OfferPackageSettingsFormDiscounts } from './OfferPackageSettingsFormDiscounts'
import { OfferPackageSettingsFormPackages } from './OfferPackageSettingsFormPackages'


export const OfferPackageSettingsForm = ({ onSuccess, onClose, offer, isOpen, title, isReadOnly, activeTab }: OfferPackageSettingsFormProps) => {
  const { app } = useApp()

  const { recalculateOffers } = useOffersContext()

  const submitCallback = () => {
    recalculateOffers([offer.offerId])
    onClose()
  }

  const groupedAvailablePackages = useGetGrouppedAvailablePackages(offer.offerId)
  const hasAnyPackageToChange = Object.values(groupedAvailablePackages).some(group => group.length > 1)


  const [tabIndex, setTabIndex] = useState(0)
  const handleTabsChange = (index: number) => {
    setTabIndex(index)
  }

  useEffect(() => {
    setTabIndex(activeTab ?? OfferPackageSettingsFormTabs.addons)
  }, [activeTab])


  return (
    <OfferSettingsModal
      title={title}
      isOpen={isOpen}
      isReadOnly={isReadOnly}
      onClose={onClose}
    >
      <Tabs
        onChange={handleTabsChange}
        index={tabIndex}
      >
        <TabList mb={4}>
          <Tab>Připojištění</Tab>

          <Tab isDisabled={!hasAnyPackageToChange}>Balíčky</Tab>

          <Tab>Slevy</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            {<OfferPackageSettingsFormAddons offer={offer} isReadOnly={isReadOnly} submitCallback={submitCallback} />}
          </TabPanel>

          <TabPanel>
            {<OfferPackageSettingsFormPackages offer={offer} isReadOnly={isReadOnly} submitCallback={submitCallback} />}
          </TabPanel>

          <TabPanel>
            {<OfferPackageSettingsFormDiscounts offer={offer} isReadOnly={isReadOnly} submitCallback={submitCallback} />}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </OfferSettingsModal>
  )
}